import React, {PureComponent} from 'react';
import ChartLoader from '../../utils/chart-loader';

class SinglePaymentMethodSelect extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    getCardLogo = () => {
        let brand = this.props.method.card_brand

        return brand === 'visa' ? '/img/cards/payment-methods/visa.png' : brand === 'mastercard' ? '/img/cards/payment-methods/master-card.png' :
            brand === 'discover' ? '/img/cards/payment-methods/discover.png' : brand === 'amex' ? '/img/cards/payment-methods/amex.png' :
                '/img/cards/payment-methods/default.png'
    }

    getThreeMonthsAhead = () =>{
        let today = new Date();
        let threeMonthsAgo = today;
        threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() + 3)
        return threeMonthsAgo
    }


    render() {
        let endDate = this.props.method.ends_at;
        let date = endDate.substring(0, 4);
        let month = endDate.substring(5,7);
        let day = endDate.substring(8,10);
        let today = new Date();
        let threeMonthsAhead = this.getThreeMonthsAhead();
        let expiringSoon = new Date(date, month, day) < threeMonthsAhead
        return (
            <div onClick={this.props.handleClick} className={this.props.isActive ? 'single-payment-method-select-container active' : 'single-payment-method-select-container'}>
                <div className='image-name-container'>
                    <div className={this.props.isActive ? 'radioSelected' : 'radio'}>
                        <div className='circle'/>
                    </div>
                    <img src={this.getCardLogo()} />
                    <div className='name-card-container'>
                        <p className='card-number'>**** **** **** {this.props.method.card_last_four}</p>
                        <p className='card-name'>{this.props.method.billing_details ? this.props.method.billing_details.billing_name : 'No billing name'}</p>
                    </div>
                </div>
                <div className='date-card-container'>
                    <p className='card-number'>{this.props.method && this.props.method.ends_at ?
                        (this.props.method.ends_at.substring(5,7)+'/'+this.props.method.ends_at.substring(2,4)) : ''}</p>
                    {expiringSoon ? <p className='card-expires-soon'>expiring soon</p> : ''}
                </div>
                {this.props.loaderActive ?
                    <div className='single-payment-method-loader-container'>
                        <ChartLoader/>
                    </div>
                    :
                    ''
                }
            </div>
        )
    }
}

export default SinglePaymentMethodSelect;